module.exports = __webpack_public_path__ + "static/media/MSW_03.10a2295f.jpg";